module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "machine",
    on: {
      "click": function($event) {
        _vm.openUrl(_vm.machine.url)
      }
    }
  }, [_c('a', {
    staticClass: "img",
    attrs: {
      "href": _vm.machine.url
    }
  }, [_c('span', {
    staticClass: "machine-top"
  }, [_c('img', {
    attrs: {
      "src": _vm.machine.thumbnail,
      "alt": ""
    }
  }), _vm._v(" "), (_vm.machine.isHot) ? _c('span', {
    staticClass: "flag flag-special"
  }, [_vm._v(_vm._s(_vm.texts.specialOffer))]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "info"
  }, [_c('span', {
    staticClass: "h3"
  }, [_vm._v(_vm._s(_vm.machine.name))]), _vm._v(" "), _c('span', {
    staticClass: "h4"
  }, [_vm._v(_vm._s(_vm.machine.machineType))])])]), _vm._v(" "), _c('span', {
    staticClass: "bar"
  }, [_c('span', {
    staticClass: "bar-item"
  }, [_c('i', [_vm._v(_vm._s(_vm.texts.referenceNumberShort))]), _vm._v(" " + _vm._s(_vm.machine.referenceNumber))]), _vm._v(" "), _c('span', {
    staticClass: "bar-item"
  }, [_c('i', [_vm._v(_vm._s(_vm.texts.productionYear))]), _vm._v(" " + _vm._s(_vm.machine.productionYear))]), _vm._v(" "), _c('span', {
    class: {
      'active': _vm.machine.isFavourite, 'add-to-favourites': true
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.toggleFavourites(_vm.machine)
      }
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1954d2ac","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./Content/Modern/js/vue/_machine.vue
// module id = 114
// module chunks = 1